<template>
  <div class="data">
    <div :ref="id"></div>
  </div>
</template>

<script>
  import { getChartFontSize } from '@/utils'
  export default {
    props: ['chartData', 'id'],
    data() {
      return {
        myChart: undefined,
        resizeHandler: null
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      this.resizeHandler = _ => {
        this.debounceResize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    mounted() {
      this.initEchart()
    },
    methods: {
      resize() {
        try {
          this.myChart.resize()
        } catch (e) {
          console.log(e)
        }
      },
      initEchart() {
        if (this.myChart) this.myChart.dispose()
        let dom = this.$refs[this.id]
        let myChart = this.$echarts.init(dom)
        this.myChart = myChart
        this.myChart.setOption(this.getOption())
      },
      getOption() {
        let option
        option = {
          background: 'none',
          legend: {
            show: false
          },
          grid: {
            top: '10%',
            left: '5%',
            right: '7%',
            bottom: '10%',
            containLabel: true
          },
          color: ['#5eaeff', '#ff7538'],
          series: [
            {
              name: '设备统计',
              type: 'pie',
              radius: ['25%', '70%'],
              center: ['25%', '50%'],
              roseType: 'radius',
              labelline: {
                show: false
              },
              label: {
                show: false
              },
              data: this.chartData.data
            }
          ]
        }
        return option
      },
      refresh() {
        this.myChart.clear()
        this.myChart.setOption(this.getOption())
      }
    },
    watch: {
      chartData: {
        handler() {
          this.$nextTick(() => {
            this.refresh()
          })
        },
        deep: true
      }
    },
    destroyed() {
      if (this.myChart) this.myChart.dispose()
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      if (this.debounceResize && this.debounceResize.cancel) {
        this.debounceResize.cancel()
      }
    }
  }
</script>

<style lang="less" scoped>
  .data {
    width: 100%;
    height: 100%;
    background-size: 100%;
    div {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/deviceCharts.vue